import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { customEvent } from '@ps/web-core-utils';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import type { Dispatch } from '@swf/core/store';

const useSignup = () => {
  const swcSignupFlag = useFeature(FeatureFlag.SwcSignup);
  const { modal } = useDispatch<Dispatch>();
  const { push } = useHistory();
  const bankID = useFeature(FeatureFlag.BankID);

  const openRegistrationModal = useCallback(
    (event: { preventDefault: () => void }) => {
      event.preventDefault();
      customEvent({ tag: 'WF_ClickToJoin' });
      if (swcSignupFlag) {
        push('/signup');
        return;
      }

      if (bankID) {
        modal.enqueue({ path: '/auth/registration/bankid' });
        return;
      }
      modal.enqueue({ path: '/auth/registration' });
    },
    [bankID, modal, push, swcSignupFlag]
  );

  return (event: { preventDefault: () => void }) => {
    event.preventDefault();
    openRegistrationModal(event);
  };
};

export default useSignup;
